import { useEffect, useState } from "react";
import * as S from "./CookieConsent.styles";
import { Button } from "../Button/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation(["common"]);

  useEffect(() => {
    const consent = localStorage.getItem("tracker_cookie_consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("tracker_cookie_consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("tracker_cookie_consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <S.ConsentContainer>
      <S.ConsentText>
        {t(
          "common:cookie_text_1",
          'We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies. Read our ',
        )}
        <Link to="/privacy">
          {t("common:cookie_policy_link", "Privacy Policy")}
        </Link>
        {t("common:cookie_text_2", " for more information.")}
      </S.ConsentText>
      <S.ButtonsContainer>
        <Button variant="secondary" onClick={handleDecline}>
          {t("common:cookie_decline", "Decline")}
        </Button>
        <Button variant="primary" onClick={handleAccept}>
          {t("common:cookie_accept", "Accept All")}
        </Button>
      </S.ButtonsContainer>
    </S.ConsentContainer>
  );
};
